import {
  HIDE_LOADING_PROGRESS,
  MENU,
  MULTI_SECTION_LIST_ACTIONS, SET_CURRENT_GNB, SET_CURRENT_MENU,
  SHOW_LOADING_PROGRESS
} from '@/common/resources/const'
import _ from 'lodash'
import fp from 'lodash/fp'
import { GNB_EVENT_LIST } from '@/common/utils/gnb.fp'
import { fetchFromEventObject } from '@/common/utils/request'
const state = {
  currentMenu: MENU.HOME,
  currentGnb: MENU.HOME,
  [MENU.HOME]: {
    GNBData: null,
    multiSectionList: []
  },
  [MENU.BROADCAST]: {
    GNBData: null,
    multiSectionList: []
  },
  [MENU.LIVE]: {
    GNBData: null,
    multiSectionList: []
  },
  [MENU.MOVIE]: {
    GNBData: null,
    multiSectionList: []
  },
  [MENU.GLOBAL]: {
    GNBData: null,
    multiSectionList: []
  },
  [MENU.CLIP]: {
    GNBData: null,
    multiSectionList: []
  },
  bandMemorize: {},
  isBandLoading: false,
  beforeEnterPath: ''
}
const getters = {
  multiSectionList (state) {
    return state[state.currentGnb].multiSectionList
  },
  isBandLoading (state) {
    return state.isBandLoading
  },
  currentMenu (state) {
    return state.currentMenu
  },
  currentGnb (state) {
    return state.currentGnb
  }
}

const actions = {
  async [MULTI_SECTION_LIST_ACTIONS.FETCH] (context, { gnbName = MENU.HOME, force = false }) {
    context.commit(SHOW_LOADING_PROGRESS)
    const { onContent, onClick } = GNB_EVENT_LIST[gnbName]
    fetchFromEventObject(onClick) // 비동기
    const { data } = await fetchFromEventObject(onContent)
    const existGNBData = _.get(state, [gnbName, 'GNBData'], null)
    const getGenTime = fp.getOr('', 'gen_time')
    if (force || existGNBData === null || (getGenTime(existGNBData) !== getGenTime(data))) { // 기존 데이터가 없음으로 무조건 셋팅
      state[gnbName].GNBData = data
      state[gnbName].multiSectionList = _.get(data, 'multisectionlist', [])
    }
    context.commit(HIDE_LOADING_PROGRESS)
  }
}

const mutations = {
  [SET_CURRENT_MENU] (state, menuName) {
    state.currentMenu = menuName
  },
  [SET_CURRENT_GNB] (state, gnbName) {
    state.currentGnb = gnbName
  },
  [SHOW_LOADING_PROGRESS] (state) {
    state.isLoading = true
  },
  [HIDE_LOADING_PROGRESS] (state) {
    state.isLoading = false
  }
}

export default { state, getters, actions, mutations }
